export default "__VITE_ASSET__ab070686__"